import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import {
  ActiveMember,
  PendingInvitationMember,
  isActiveMember,
} from '../types/members-types';
import PendingInviteTableRow from './PendingInviteTableRow';
import MemberTableRow from './MemberTableRow';
import { useCallback } from 'react';
import { Box } from '@mui/material';
import { isMemberCurrentUser } from '../store-actions/remove-member-store-actions';

export interface IMemberListProps {
  activeMembers: ActiveMember[];
  pendingInvitationMembers: PendingInvitationMember[];
  isReadOnlyUser: boolean;
}

const MembersTable: React.FC<React.PropsWithChildren<IMemberListProps>> = ({
  activeMembers,
  pendingInvitationMembers,
  isReadOnlyUser,
}) => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = useCallback((_: unknown, newPage: number) => {
    setPage(newPage);
  }, []);

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const members = [...activeMembers, ...pendingInvitationMembers];

  return (
    <Box component={Paper} width='100%' overflow='hidden'>
      <TableContainer>
        <Table stickyHeader aria-label='sticky table'>
          <TableHead>
            <TableRow>
              <TableCell key='name' align='left' style={{ minWidth: 50 }}>
                Name
              </TableCell>
              <TableCell key='Email' align='left' style={{ minWidth: 100 }}>
                Email
              </TableCell>
              <TableCell key='roles' align='left' style={{ minWidth: 100 }}>
                Roles
              </TableCell>
              <TableCell key='status' align='left' style={{ minWidth: 100 }}>
                Status
              </TableCell>
              <TableCell
                key='more'
                align='right'
                style={{ minWidth: 100 }}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {members
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map(member => {
                return isActiveMember(member) ? (
                  <MemberTableRow
                    key={member.user_id}
                    activeMember={member}
                    isReadOnlyUser={isReadOnlyUser}
                    isSelf={isMemberCurrentUser(member)}
                  />
                ) : (
                  <PendingInviteTableRow
                    key={member.id}
                    pendingInvitationMember={member}
                    isMoreButtonDisabled={isReadOnlyUser}
                  />
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component='div'
        count={activeMembers.length + pendingInvitationMembers.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  );
};

export default MembersTable;
